export default __webpack_public_path__ + "static/media/1.947e6f45.jpg";